import { useState, useEffect } from 'react';

export default function useUserSelectedColumns() {
  const [userSelectedColumns, setUserSelectedColumns] = useState(() => {
    const saved = localStorage.getItem('userSelectedColumns');
    return saved ? JSON.parse(saved) : [];
  });

  useEffect(() => {
    localStorage.setItem('userSelectedColumns', JSON.stringify(userSelectedColumns));
  }, [userSelectedColumns]);

  useEffect(() => {
    const saved = localStorage.getItem('userSelectedColumns');
    if (saved) {
      setUserSelectedColumns(JSON.parse(saved));
    }
  }, []);

  // Sync across tabs/windows
  useEffect(() => {
    const syncHandler = (e) => {
      if (e.key === 'userSelectedColumns') {
        setUserSelectedColumns(e.newValue ? JSON.parse(e.newValue) : []);
      }
    };
    window.addEventListener('storage', syncHandler);
    return () => window.removeEventListener('storage', syncHandler);
  }, []);

  return [userSelectedColumns, setUserSelectedColumns];
}
